import { v4 as uuid } from 'uuid';
import {
  BindersApi,
  BookshelvesApi,
  CustomersApi,
  UsersApi
} from '../../Utils/apis';
import { iBinderFetch } from '../../Utils/iBinderFetch';
import {
  CleanupImpersonation,
  ImpersonateUser
} from '../../Utils/ImpersonateUser';
import { impersonateTenderUser } from 'src/components/AdminBinder/AdminContentContainer/TabContent/ListContainer/AdminActionBar';
import { ImpersonateTenant } from '../../Utils/impersonateTenant';

const id = uuid();
const githubUrl = `https://github.com/iBinder/admins-ui/tree/main/${__filename}`;

// *****************************************************************************
// START - The part between START and END is the part that is added to the file.
// *****************************************************************************
const name = 'Filips';
const description = 'sfdsafds';

// The input model
export interface AddInput {
  userId?: string;
}

// The sample input, prefilled in the editor
const sample: AddInput = { userId: '6fde6b81-f84c-4fd0-df74-08d7daf43f3f' }; //Sani

// The actual function called with the input
const fn =
  ({ tenantId }) =>
  async ({ userId }: AddInput) => {
    // const tenantFetch = iBinderFetch({ tenantId });
    // const a = iBinderFetch(); // Just to try initiate without tenantId

    const theUsers = [
      '5c3a714c-d38f-4988-0530-08d6ac83c4d4',
      'b438e542-86e8-4371-c0be-08d7c6cbf4d6',
      '0e04a22b-d959-458c-724d-08d9d732e14e',

      '8fd608ac-2f8c-4652-47ea-08d9d7340445',

      '83aa4d60-eb19-41b8-78cd-08d996d2ad90',

      '4d5f9b8e-bd2c-4a2a-051e-08d6ac83c4d4',

      '39a9b35e-db8b-48e1-0f17-08d9ed1eaa58',

      '597ce533-fd8b-4d92-aa79-08db797fe694',

      'bcc4aae5-2772-4f16-fe52-08d7c6cbf419',

      '45ab539e-fe39-4188-335c-08db797ae332',

      '3c3f01d9-5eba-4735-61f0-08d7c6cbf419',

      '447db039-12f2-4dc6-b377-08d7c6bd7f8c',

      '7e2770bb-f309-47be-151e-08d7c6bd7f8d',

      '4eeeee3e-dc63-4441-7158-08d7c6cbf419',

      '75acfe2c-a6ab-45db-a0f3-08db79792a4b',

      '79f304cd-173c-4d7c-cc8c-08d6ac95648d',

      'b37e5603-49ee-4917-84cf-08d86f838ed6',

      '6709f289-088b-428e-c9b5-08dae362b97c',

      '4e19b2e9-97e9-415f-5386-08d7c6bd7f72',

      'd42a0ab3-d2fb-4b5d-ebb5-08da134a755e',

      'd0ef1d39-c636-464d-e79a-08da134a755e',

      '54b6728e-09c6-440f-44f9-08db2fbd6a98',

      '22b744ee-6a34-4ea7-785f-08d7c6cbf419',

      'cae65ab9-fca3-4a38-9557-08d7c6cbf4d6',

      '59b91be0-8a88-4881-5f80-08d7c6bd7f8d'
    ];

    const Users = [];
    theUsers.forEach(async (userId) => {
      const User = (await iBinderFetch()(`${UsersApi}/${userId}`)).json();

      Users.push(User);
    });

    return JSON.stringify({
      FilipsUSer: Users
    });
  };

// *****************************************************************************
// END - The part between START and END is the part that is added to the file.
// *****************************************************************************

export default {
  onSubmit:
    ({ tenantId }) =>
    async (jsonData) =>
      await fn({ tenantId })(jsonData),
  sample,
  id,
  name,
  description,
  githubUrl
};
